import * as React from 'react';
import { useContext, useRef, useState } from 'react';
import {
  Button,
  Dialog,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import { DialogRoot } from './DialogRoot';
import Box from '@mui/material/Box';
import { UploadFile } from '@mui/icons-material';
import { TitleDialog } from './TitleDialog';
import { ChildVideo, VideoManagerItem } from '../types/videos';
import { OrganisationContext } from '../../App';
import { DownloadArea } from '../common/DownloadArea';
import { apiUploadVideoProvider } from '../../store/videoManagerSlice';
import { useDispatch } from 'react-redux';

type UploadVideoProps = {
  open: boolean,
  handleClose: () => void,
  title?: string,
  video?: VideoManagerItem | ChildVideo,
}

export const ReUploadVideo = ({ open, handleClose, video, title = 'Re-upload video' }: UploadVideoProps) => {
  const dispatch = useDispatch();
  const { selectedOrganisation } = useContext(OrganisationContext);
  const [file, setCurrentFile] = useState<File>();
  const [videoTitle, setVideoTitle] = useState<string>('');
  const dropArea = useRef<HTMLDivElement>();
  const inputFile = useRef<HTMLInputElement>(null);

  const dropFileCallback = (files: FileList | null) => {
    if (files && files.length > 0) {
      const [droppedFile] = files;
      if (!/mp4$/.test(droppedFile.type)) {
        alert('Unsupported file type, please upload mp4 video');
        return;
      }
      setCurrentFile(droppedFile);
    }
  };

  const upload = async () => {
    dispatch(apiUploadVideoProvider({
      publisher: selectedOrganisation,
      file,
      video,
      title: videoTitle
    }));
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth={'sm'}>
      <DialogRoot handleClose={handleClose}>
        <TitleDialog>{title}</TitleDialog>
        <Box sx={{ pl: 4, pr: 4, pb: 4, position: 'relative' }}>

          <Grid container spacing={2} style={{ marginTop: 0 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Video Title"
                value={videoTitle}
                onChange={(e) => setVideoTitle(e.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <DownloadArea
                ref={dropArea}
                draggable
                onDrop={(e) => {
                  e.preventDefault();
                  dropFileCallback(e.dataTransfer.files);
                  dropArea?.current?.removeAttribute('drop-active');
                }}
                onDragOver={(e) => {
                  e.preventDefault();
                  dropArea?.current?.setAttribute('drop-active', '');
                }}
                onDragLeave={() => dropArea?.current?.removeAttribute('drop-active')}
              >
                {!file &&
                  <Typography sx={{ m: 4, textAlign: 'center' }}>Drag and drop video you want to
                    upload here, or choose 'Add video'.</Typography>}
                {file && <Typography sx={{
                  m: 4,
                  textAlign: 'center',
                  wordBreak: 'break-word'
                }}>{file.name}</Typography>}
              </DownloadArea>
            </Grid>
            <Grid item xs={12}>
              <Grid container justifyContent={'space-between'}>
                <Button variant={'outlined'} startIcon={<UploadFile/>}
                        onClick={() => inputFile.current?.click()}>
                  Add video
                  <input
                    ref={inputFile}
                    type="file"
                    onChange={(e) => dropFileCallback(e.target.files)}
                    accept="video/mp4"
                    hidden
                  />
                </Button>
                <Button disabled={!file} onClick={upload} variant={'contained'}
                        startIcon={<UploadFile/>}>{ 'Upload'}</Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogRoot>
    </Dialog>
  );
};
